module.exports = __webpack_public_path__ + "static/media/logo-soma@3x.46471f21.png";